export const APP_CODE_NAME = 'YRNewsPlayer';
export const IS_TEST_ENVIRONMENT = process.env.NODE_ENV === 'test';
export const IS_PRODUCTION_ENVIRONMENT = process.env.NODE_ENV === 'production';
export const IS_EMITTING_LOG_EVENTS_DISABLED =
  process.env.REACT_APP_EMIT_LOG_EVENTS_DISABLED === 'true';
